import { usePhaseClock } from "@/lib/productionScheduleUi";

export default function KitchenSchedulePhaseRow({ title, stage, pillClass = "" }) {
  const { label, phase, durationLabel } = usePhaseClock(stage);
  if (!stage || !durationLabel) return null;

  return (
    <div className="kitchen-phase-row">
      <div className="kitchen-phase-row-top">
        <span className="kitchen-phase-title">{title}</span>
        <span className={`kitchen-phase-dur-pill ${pillClass}`.trim()}>{durationLabel}</span>
        {label ? (
          <span className={`kitchen-phase-clock kitchen-phase-clock--${phase || "upcoming"}`}>
            {label}
          </span>
        ) : null}
      </div>
      {stage.start_label_ist || stage.end_label_ist ? (
        <div className="kitchen-phase-sub">
          {stage.start_label_ist ? <span>Start {stage.start_label_ist}</span> : null}
          {stage.start_label_ist && stage.end_label_ist ? <span className="kitchen-phase-sub-sep"> · </span> : null}
          {stage.end_label_ist ? <span>Finish {stage.end_label_ist}</span> : null}
        </div>
      ) : null}
    </div>
  );
}

export const KITCHEN_SCHEDULE_PHASE_CSS = `
  .kitchen-schedule-card {
    background: white;
    border: 1px solid rgba(235, 179, 169, 0.55);
    border-radius: 14px;
    padding: 12px 14px;
    margin-bottom: 10px;
  }
  .kitchen-schedule-card-title {
    font-size: 11px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #6B4E57;
    margin-bottom: 10px;
  }
  .kitchen-phase-row + .kitchen-phase-row {
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px dashed rgba(235, 179, 169, 0.55);
  }
  .kitchen-phase-row-top {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;
  }
  .kitchen-phase-title {
    font-size: 12px;
    font-weight: 800;
    color: #2D2D2D;
  }
  .kitchen-phase-dur-pill {
    font-size: 9px;
    font-weight: 800;
    padding: 3px 8px;
    border-radius: 999px;
    background: #F3E8FF;
    color: #6B21A8;
    text-transform: uppercase;
  }
  .kitchen-phase-dur-pill--fondant {
    background: #FEF3C7;
    color: #92400E;
  }
  .kitchen-phase-dur-pill--decor {
    background: #FCE7F3;
    color: #9D174D;
  }
  .kitchen-phase-clock {
    margin-left: auto;
    font-size: 12px;
    font-weight: 800;
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
  }
  .kitchen-phase-clock--upcoming { color: #15803D; }
  .kitchen-phase-clock--active { color: #B45309; }
  .kitchen-phase-clock--late { color: #B91C1C; }
  .kitchen-phase-sub {
    margin-top: 3px;
    font-size: 10px;
    font-weight: 600;
    color: rgba(45, 45, 45, 0.55);
  }
  .kitchen-fondant-tag {
    display: inline-flex;
    font-size: 8px;
    font-weight: 800;
    padding: 2px 7px;
    border-radius: 999px;
    background: #FEF3C7;
    color: #92400E;
    text-transform: uppercase;
  }
`;
